import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'unixTimeToDaysFromNow',
    standalone: false,
})
export class UnixTimeToDaysFromNowPipe implements PipeTransform {
    transform(time: number): number {
        return moment.unix(time).diff(moment(), 'days');
    }
}
